import atlasEmptyState from 'src/components/CategoryConfiguration/assets/atlas-empty-state.svg';
import {
  FormsTableEmptyStateDescription,
  FormsTableEmptyStateRoot,
  FormsTableEmptyStateTitle,
  VisuallyHiddenLiveRegion,
} from './CoiFormManagement.styles';

export interface FormsTableEmptyStateProps {
  message: string;
}

const EMPTY_STATE_TITLE = 'No results found';
const EMPTY_STATE_DESCRIPTION =
  'Review your filters or refine your search to view more results.';

export function FormsTableEmptyState({ message }: FormsTableEmptyStateProps) {
  return (
    <FormsTableEmptyStateRoot data-testid="forms-table-filter-empty-state">
      <VisuallyHiddenLiveRegion aria-live="polite" aria-atomic="true">
        {message}
      </VisuallyHiddenLiveRegion>
      <img src={atlasEmptyState} alt="" width={160} height={132} />
      <FormsTableEmptyStateTitle>{EMPTY_STATE_TITLE}</FormsTableEmptyStateTitle>
      <FormsTableEmptyStateDescription>
        {EMPTY_STATE_DESCRIPTION}
      </FormsTableEmptyStateDescription>
    </FormsTableEmptyStateRoot>
  );
}
